var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarnningYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.543 5.87a1.655 1.655 0 0 1 2.914 0l6.335 11.64c.61 1.12-.193 2.49-1.458 2.49H5.666c-1.265 0-2.067-1.37-1.458-2.49l6.335-11.64Z",
    fill: "#FCB519"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.032 9a1.638 1.638 0 0 0-1.569 2.108l.716 2.387.006.02c.026.087.05.169.09.24a.733.733 0 0 0 .48.357c.08.018.165.017.256.017h.042c.09 0 .176 0 .256-.017a.733.733 0 0 0 .48-.357c.04-.071.064-.153.09-.24l.006-.02.716-2.387A1.638 1.638 0 0 0 12.032 9ZM12.032 14.954a1.19 1.19 0 1 0 0 2.381 1.19 1.19 0 0 0 0-2.382Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarnningYellowIcon);
export default __webpack_public_path__ + "static/media/warnning-yellow-icon.afa4fe06a133c7e444c0c67f099e94d7.svg";
export { ForwardRef as ReactComponent };